import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {marketingMobileCuttoff} from "@css/constants";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export type MissionTitleContainerProps = {
  imageUrl: string
  imageUrlMobile: string
}

export const MissionTitleContainer = styled('div')<MissionTitleContainerProps>(props => css`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${props.imageUrl});
  
  @media(max-width: ${marketingMobileCuttoff}) {
    background-image: url(${props.imageUrlMobile || props.imageUrl});
    padding: 84px 0;
    margin-bottom: 30px;
    height: 230px;
  }
`);

export const TitleContent = styled('div')(css`
  height: 480px;
`)

export const TitleTextWrapper = styled('div')(css`
  width: 90%;
  margin: 0 auto;
  padding-top: 140px;
  max-width: 600px;
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: 20px;
  }
`)

export const Title = styled('h1')(css`
  ${FontNormal(600)}
  ${fontSize(40)}
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  color: white;
  padding-bottom: 60px;
  letter-spacing: unset;

  @media(max-width: ${marketingMobileCuttoff}) {
    max-width: 600px;
    text-align: start;
  }
`)